import { createAction, handleActions } from 'redux-actions';
import { takeLatest, call } from 'redux-saga/effects';
import * as userAPI from '../../lib/api/userapi';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';


// 회원 가입 확인 
const [CHECK, CHECK_SUCCESS, CHECK_FAILURE] = createRequestActionTypes(
    'user/CHECK',
);

// 미로그인 상태에서 비밀번호 변경 
const [CHANGE, CHANGE_SUCCESS, CHANGE_FAILURE] = createRequestActionTypes(
    'user/CHANGE',
);

// 마이페이지에서 비밀번호 변경 
const [CHANGE_MYPW, CHANGE_MYPW_SUCCESS, CHANGE_MYPW_FAILURE] = createRequestActionTypes(
    'user/CHANGE_MYPW',
);

// 아이디 찾기  
const [FIND, FIND_SUCCESS, FIND_FAILURE] = createRequestActionTypes(
    'user/FIND',
);

const RESET = 'user/RESET';
const RESET_CHANGE = 'user/RESERT_CHANGE';

// Action 정의 
export const checkAction = createAction(CHECK, (email, confirmData) => {
    return { email, confirmData }
});

export const findAction = createAction(FIND, (confirmData) => {
    return { confirmData }
});

// 미로그인 상태에서 비밀번호 변경 
export const changePwAction = createAction(CHANGE, (token, pw) => {
    return { token, pw }
});

// 마이페이지에서 비밀번호 변경 
export const changeMyPwAction = createAction(CHANGE_MYPW, (token, pw, newpw) => {
    return { token, pw, newpw }
});

export const resetStatusAction = createAction(RESET);
export const resetChangeStatusAction = createAction(RESET_CHANGE);

// Make Saga I/F
const checkSaga = createRequestSaga(CHECK, userAPI.checkid);
const changePwSage = createRequestSaga(CHANGE, userAPI.changepw);
const changeMyPwSage = createRequestSaga(CHANGE_MYPW, userAPI.changeMypw);
const findSaga = createRequestSaga(FIND, userAPI.findid);

export function* userCheckSaga() {
    yield takeLatest(CHECK, checkSaga);
    yield takeLatest(CHANGE, changePwSage);
    yield takeLatest(CHANGE_MYPW, changeMyPwSage);
    yield takeLatest(FIND, findSaga);
}

/**
 * 리덕스 모듈 초기값 
 */
const initialState = {
    checkStatus: null,
    message: null,
    changeStatus: null,
};

/**
 * 리덕스 액션 연결 
 */
const userCheckReducer = handleActions(
    {
        [CHECK]: (state) => ({
            ...state,
            checkStatus: null,
            message: null,
            changeStatus: null,
        }),
        [CHECK_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                checkStatus: payload.code * 1,
                message: payload.message
            })
        },
        [CHECK_FAILURE]: (state, { payload: error }) => ({
            ...state,
            checkStatus: 500,
            message: error
        }),
        [CHANGE]: (state) => ({
            ...state,
            message: null,
            changeStatus: null,
        }),
        [CHANGE_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                changeStatus: payload.code * 1,
                message: payload.message
            })
        },
        [CHANGE_FAILURE]: (state, { payload: error }) => ({
            ...state,
            changeStatus: 500,
            message: error
        }),
        [CHANGE_MYPW_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                changeStatus: payload.code * 1,
                message: payload.message
            })
        },
        [CHANGE_MYPW_FAILURE]: (state, { payload: error }) => ({
            ...state,
            changeStatus: 500,
            message: error
        }),
        [RESET]: (state) => ({
            ...state,
            checkStatus: null,
            message: null,
            changeStatus: null,
        }),
        [RESET_CHANGE]: (state) => ({
            ...state,
            changeStatus: null,
        }),
        [FIND]: (state) => ({
            ...state,
            checkStatus: null,
            message: null,
            changeStatus: null,
        }),
        [FIND_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                checkStatus: payload.code * 1,
                message: payload.message
            })
        },
        [FIND_FAILURE]: (state, { payload: error }) => ({
            ...state,
            checkStatus: 500,
            message: error
        }),
    },
    initialState,
);

export default userCheckReducer;